<template>
 <div class="paperweb-preview">
    <div class="btn-container" v-if="!preview">
      <button type="button" class="btn btn-primary edit-button" v-on:click="startEdit"><i class="fas fa-edit"></i> 編集する</button>
    </div>
   <div style="clear: both"></div>
    <div v-for="(item,index) in contentItems" :key="`item-` + index">
      <div v-if="item.type === 'h1'">
        <h1>{{item.value}}</h1>
      </div>

      <div v-else-if="item.type === 'h2'">
        <h2>{{item.value}}</h2>
      </div>

      <div v-else-if="item.type === 'h3'">
        <h3>{{item.value}}</h3>
      </div>

      <div class="content" v-else-if="item.type === 'p'" v-html="toHtml(item.value)"></div>

      <div v-else-if="item.type === 'blockquote'">
        <blockquote v-html="toHtml(item.value)"></blockquote>
      </div>

      <div v-else-if="item.type === 'movie'" class="movie">
        <iframe width="560" height="315"
                :src="`https://www.youtube.com/embed/${item.value}`"
                title="YouTube video player" frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen>
        </iframe>
      </div>

      <div v-else-if="item.type === 'img'" class="image-container">
        <img :src="item.url" class="img-fluid"/>
        <div v-if="item.caption" class="caption">
          {{item.caption}}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import showdown from 'showdown'

export default {
  name: "paperweb-preview",
  props: ['contentItems', 'preview'],
  methods: {
    startEdit() {
      this.$emit("startEdit")
    },

    markdownToHTML: function(text) {
      const converter = new showdown.Converter();
      return converter.makeHtml(text);
    },

    toHtml(str) {
      if(str) {
        return this.markdownToHTML(str.replace(/\r?\n/g, "<br/>"))
      }
      else {
        return  ''
      }
    }
  }
}
</script>

<style scoped>

</style>